// modules/Lot.js
import React from 'react';
import $ from 'jquery';
import BackButton from '../common/BackButton';
import SiteDownloads from '../common/SiteDownloads';
import PageLoading from '../PageLoading';
import SimilarPackageGrid from '../common/SimilarPackageGrid';
import wNumb from 'wnumb';

let sources = require('../config.json');

let priceFormat = wNumb({
	prefix: '$',
	decimals: 0,
	thousand: ','
});

let existingVars = null;

import { onEnquireClick } from '../common/onEnquireClick';
import getPpsUrl from '../common/ppsUrl';

class Lotplan extends React.Component {
    constructor(props) {
        super(props);

	    var d = new Date();
        this.lotplan_url = sources.lotplan + '/' + this.props.params.lot + "?ts=" + d.getTime();

        this.state = {
            data: {
                lot: {},
                stage: {},
                downloads: [],
                packages: []
            },
        };
        this.receivedLotplanData = this.receivedLotplanData.bind(this);
        this.downloadLotFlyer = this.downloadLotFlyer.bind(this);
    }

    componentDidMount() {
	    window.scrollTo(0,0);
        $.ajax({url: this.lotplan_url, dataType: 'json'}).done(this.receivedLotplanData);
    }

    receivedLotplanData(data, status, xhr) {
        if (typeof data.lot === 'undefined') data.lot = [];
        if (typeof data.stage === 'undefined') data.stage = [];
        if (typeof data.downloads === 'undefined') data.downloads = [];
        if (typeof data.packages === 'undefined') data.packages = [];

        let newState = Object.assign(this.state, {
            data: data
        });
        this.setState(newState);
        //document.getElementById('reloadScroll').scrollIntoView()
    }

    downloadLotFlyer(file) {
        if (file !== "") {
            return (
                <li className="p-t-1 p-b-1-md brd-top no-hov">
                    <div className="btn__container tc tl-md">
                        <a className="btn btn__action--rev w-80-lg w-100" href={file} target="_blank"><i
                            className="icon icon--download"></i><span>DOWNLOAD LOT FLYER</span></a>
                    </div>
                </li>
            );
        } else {
            return null;
        }
    }

    downloadPps(file) {
        const url = getPpsUrl(file);
        if (!url) {
            return null;
        }
        return (
            <li className="p-t-1 p-b-1-md brd-top no-hov">
                <div className="btn__container tc tl-md">
                    <a className="btn btn__action--rev w-80-lg w-100" href={url} target="_blank" rel="noopener noreferrer"><i
                        className="icon icon--download"></i><span>DOWNLOAD PPS</span></a>
                </div>
            </li>
        );
    }

    render() {
        if (typeof this.state.data.lot.lot_name !== "undefined") {
            let lotStatus = <span className="fcolor-gr no-wrap">Now Selling</span>;
            let lotFrontage = '';

            if (this.state.data.lot.lot_status === 2) {
                lotStatus = <span className="fcolor-gray">Sold</span>;
            }

            if (this.state.data.lot.lot_status === 3) {
                lotStatus = <span className="fcolor-bl"><br/>Builder Exclusive</span>;
            }

			if (this.state.data.lot.lot_status === 6) {
				lotStatus = <span className="fcolor-gr"><br/>Coming Soon</span>;
			}

			switch(this.state.data.lot.lot_type) {
				case 'Irregular Lot':
					lotFrontage = 'Irregular';
					break;
				case 'Corner Lot':
					lotFrontage = 'Corner';
					break;
				default:
					lotFrontage = this.state.data.lot.lot_frontage + 'm';
			}

            // let comment = "Please provide information regarding Lot " + this.state.data.lot.lot_name;

	        let price = priceFormat.to(parseInt(this.state.data.lot.lot_price,10));

            return (
                <div className="App">
                    <div id="reloadScroll"></div>
                    <section className="section p-t-2">
                        <div className="container">
                            <div className="section__content tc">
                                <h1 className="title f3 f4-md f-headline-lg m-b-0">Land For Sale</h1>
                            </div>
                        </div>
                    </section>
                    <section className="section p-h-1 p-h-3-lg section-bg-white land-filter-section">
                        <div className="container">
                            <div className="cf top-land-filter-section m-b-3-lg m-b-1">
                                <div className="w-100">
									<BackButton link={this.state.data.stage.stage_link}/>
									<div className="cf"></div>
                                </div>
                                <div className="w-100 db dn-lg">
	                                <div className="tc tl-md brd-top p-v-1 w-100  small-grey-font">
		                                <h2 className="lot-measure fcolor-og">{this.state.data.stage.stage_name}</h2>
	                                </div>
                                    <div className="tc tl-md p-a-1 w-100 small-grey-font">
                                        <h2 className="lot-title">Lot {this.state.data.lot.lot_name} - {lotStatus}</h2>
	                                    <h2 className="lot-price-style lot-measure fcolor-og">{price}</h2>
                                    </div>
                                    <div>
                                        <p className="tc tl-md p-a-1 w-100 fl m-b-05 m-b-0-wd small-grey-font">Frontage<span
                                            className="fcolor-og small-grey-font"> {lotFrontage}</span>
                                            &nbsp;&nbsp;Land Size<span
                                                className="fcolor-og small-grey-font"> {this.state.data.lot.lot_area}m<sup>2</sup></span>
                                        </p>
                                    </div>
                                    <div className="p-a-1 w-100 tc tl-md">
                                        <div className="btn__container tc tl-md">
                                            <a className="btn btn__action js-registrationModal w-80-lg w-100"
                                            onClick={(ev) => onEnquireClick(ev, "", "", this.state.data.lot.lot_name)}><span className="enquire-lot">Enquire about this lot</span></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="w-100 w-70-lg fr-lg p-v-1-md">
                                    <img src={this.state.data.lot.lot_image} alt="" width="100%"/>
                                </div>

                                <div className="w-100 w-30-lg fr-lg">

                                    <div className="cf">
                                        <div className="dn db-lg">
	                                        <div className="tc tl-md brd-top p-v-1 w-100  small-grey-font">
		                                        <h2 className="lot-measure fcolor-og">{this.state.data.stage.stage_name}</h2>
	                                        </div>
                                            <div className="tc tl-md p-a-1 w-100 small-grey-font">
                                                <h2 className="lot-title">Lot {this.state.data.lot.lot_name} - {lotStatus}</h2>
	                                            <h2 className="lot-price-style lot-measure fcolor-og">{price}</h2>
                                            </div>
                                            <div>
                                                <p className="tc tl-md p-a-1 w-100 fl m-b-05 m-b-0-wd small-grey-font">Frontage<span
                                                    className="fcolor-og small-grey-font"> {lotFrontage}</span>
                                                    &nbsp;&nbsp;Land Size<span
                                                        className="fcolor-og small-grey-font"> {this.state.data.lot.lot_area}m<sup>2</sup></span>
                                                </p>
                                            </div>

                                            <div className="p-a-1 w-100 tc tl-md">
                                                <div className="btn__container tc tl-md">
                                                    <a className="btn btn__action js-registrationModal w-80-lg w-100"
                                                       onClick={(ev) => onEnquireClick(ev, "", "", this.state.data.lot.lot_name)}><span
                                                        className="enquire-lot">Enquire about this lot</span></a>
                                                </div>
                                            </div>

                                        </div>

                                        <ul className="p-v-1">
                                            {this.downloadLotFlyer(this.state.data.lot.lot_pdf)}
                                            {this.downloadPps(this.state.data.lot.pps_url)}
                                        </ul>

                                    </div>

                                </div>
                            </div>
                            <SiteDownloads divClass="cf p-a-1 btm-land-filter-section m-b-3-lg m-b-1"/>
                            <SimilarPackageGrid data={this.state.data.packages}
                                                label={'Available House & Land Packages For Lot ' + this.state.data.lot.lot_name + ':'}/>
                        </div>
                    </section>
                </div>
            );
        } else {
            return (
                <PageLoading>Lot information</PageLoading>
            )
        }
    }
}
export default Lotplan;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/Lotplan.js
 **/